import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";
import AppointmentPhase from "components/Atoms/AppointmentPhase";

export const AppointmentPhaseDropdown = (props: Omit<DropdownProps<server.dto.AppointmentPhase, server.dto.AppointmentPhases>, "options">) => {
  return <BaseReactSelectDropdown
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    options={serverReference.appointmentPhases}
    getLabel={appointmentPhase => appointmentPhase.text}
    getValue={appointmentPhase => appointmentPhase.value}
    excludeKeys={props.excludeKeys}
    config={{
      isSearchable: false,
      ...props.config
    }}
    renderOption={(appointmentPhase) => <AppointmentPhase value={appointmentPhase.value} displayLabel />}
    renderSelectedValue={(appointmentPhase) => <AppointmentPhase value={appointmentPhase.value} displayLabel />}
  />;
}